module.exports = __webpack_public_path__ + "img/widget_M.510378a6.png";